<app-header *ngIf="showHeader"></app-header>
<div class="container">
  <router-outlet></router-outlet>
</div>
